var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 113,
    viewBox: "0 0 114 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M96.8798 56.4043C96.8798 78.4298 79.0246 96.2851 56.999 96.2851C34.9734 96.2851 17.1182 78.4298 17.1182 56.4043C17.1182 34.3787 34.9734 16.5234 56.999 16.5234C79.0246 16.5234 96.8798 34.3787 96.8798 56.4043ZM29.0824 56.4043C29.0824 71.8222 41.5811 84.3208 56.999 84.3208C72.4169 84.3208 84.9156 71.8222 84.9156 56.4043C84.9156 40.9864 72.4169 28.4877 56.999 28.4877C41.5811 28.4877 29.0824 40.9864 29.0824 56.4043Z",
    fill: "#111827"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6889 16.8786C57.9264 16.0406 64.2738 16.6908 70.2119 18.7759C76.1501 20.861 81.5104 24.322 85.8547 28.8757L77.198 37.1343C74.157 33.9467 70.4048 31.524 66.248 30.0644C62.0913 28.6048 57.6482 28.1497 53.2819 28.7363L51.6889 16.8786Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.70f4b062135365071de502256eb56a00.svg";
export { ForwardRef as ReactComponent };